import { InputNumber as AntInput, InputNumberProps } from 'antd'
import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledInput = styled(AntInput)<{ $preventInput?: boolean }>`
  height: 36px;
  line-height: 36px;
  input {
    height: 36px;
  }
  ${({ $preventInput }) =>
    $preventInput ? `caret-color: transparent; pointer-events: none;` : ``}
`

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .ant-input-number-handler-wrap {
    opacity: 1;
  }
  .ant-input-number {
    width: 100%;
  }
`
interface IProps extends InputNumberProps {
  title?: string
  label?: string | ReactNode
  children?: ReactNode
  placeholder?: string
  required?: boolean
  fixed?: number
  preventInput?: boolean
}

const InputNumberAnt = (props: IProps) => {
  const { t } = useTranslation()
  const {
    title,
    fixed,
    required,
    placeholder,
    preventInput,
    value,
    label,
    onChange,
    max,
    ...resPros
  } = props
  const [valuePrivate, setValuePrivate] = useState<number | undefined>(
    undefined
  )

  useEffect(() => {
    if (value) setValuePrivate(Number(value))
  }, [value])

  const handleOnChange = (number?: any) => {
    setValuePrivate(number)
    if (onChange) onChange(number)
  }
  return (
    <StyledContainer>
      <StyledLabel>
        {label ? label : t(title || '')} {required && <span>*</span>}
      </StyledLabel>
      <StyledInput
        $preventInput={preventInput}
        placeholder={t(placeholder || '')}
        onChange={handleOnChange}
        value={valuePrivate}
        {...resPros}
      />
    </StyledContainer>
  )
}

export default InputNumberAnt
